import Loadable from "react-loadable";

export const CreatePostModal = Loadable({
  loader: () => import("../../../../modules/manage-posts").then((module) => module.CreatePostModal) as Promise<any>,
  loading: () => null,
});
